import type { EChartsOption } from "echarts"

export default {
  color: ["rgba(76, 145, 246, 1)", "rgba(82, 204, 197, 1)"],
  grid: {
    top: "20%",
    left: "10%",
    right: "10%",
    bottom: "10%",
  },
  backgroundColor: "transparent",
  series: [
    // 散点系列，表示飞线起点和终点
  ],
  graphic: [
    {
      invisible: true,
    },
  ],
} as EChartsOption
